<template>
  <v-app :class="`app-env-${env}`">
    <auth-dialog :msg="msg" />

    <!-- <mainToolbar /> -->
    <v-container
      fill-height
      v-if="$store.getters.isAppLoading && $store.state.auth.authenticated"
    >
      <v-layout>
        <v-flex></v-flex>
        <v-flex class="text-center" mt-4>
          Loading MARCO UI...
          <v-progress-linear
            :size="150"
            :width="10"
            color="primary"
            indeterminate
          />
        </v-flex>

        <v-flex v-if="isAppReady" align-center>
          <v-alert :value="msg" color="error"> ERROR: {{ msg }} </v-alert>
        </v-flex>
        <v-flex />
      </v-layout>
    </v-container>

    <router-view name="toolbar" v-if="isAppReady" />
    <router-view name="leftNavDrawer" v-if="isAppReady" />
    <v-content v-if="isAppReady">
      <router-view />
    </v-content>
    <router-view name="rightNavDrawer" v-if="isAppReady" />

    <v-footer :fixed="fixed" app>
      <span class="ma-auto">&copy; 2022 McDonnell Consulting Group</span>
      <v-spacer />
      <span v-if="$store.state.auth.username">
        <strong>{{ $store.state.auth.username }}</strong>
      </span>
    </v-footer>
  </v-app>
</template>

<script>
import mainToolbar from "@/components/main_toolbar";
import authDialog from "@/components/auth";
import { mapState } from "vuex";

import "@/assets/styles.css";

export default {
  name: "App",
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Vuetify.js",
      msg: "",
      authMsg: "",
    };
  },
  async created() {
    try {
      await this.$store.dispatch("AUTHENTICATE");
    } catch (e) {
      this.msg = e.message;
    }
    try {
      await this.$store.dispatch("LOAD_CONFIG");
      await this.$store.commit("APP_READY");
    } catch (e) {
      this.msg = e.message;
    }
  },
  components: {
    mainToolbar,
    authDialog,
  },
  computed: {
    isAppReady() {
      return (
        this.$store.state.auth.authenticated && this.$store.getters.isAppReady
      );
    },
    env() {
      return process.env.NODE_ENV;
    },
  },
  watch: {
    isAppReady(ready) {
      if (ready && this.$route.query.token) {
        delete this.$route.query.token;
      }
    },
  },
};
</script>

<style>
/* .v-form.dense .v-input input {
  font-size: 13px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-top: 12px;
}

.v-form.dense .v-text-field > .v-input__control > .v-input__slot {
  margin-bottom: 4px;
}

.v-form.dense .v-input .v-input__control {
  height: 38px;
}

.v-form.dense .v-text-field {
  padding-top: 6px;
}

.v-form.dense .v-text-field .v-label {
  top: 18px;
} */

.v-cloak {
  display: none;
}

.app-env-development {
  background-color: red !important;
}
</style>
